const NON_PRODUCTION_LABELS = ['dev', 'development', 'staging', 'test'];
const isNonProductionLabel = (label) => NON_PRODUCTION_LABELS.includes(label) ||
    NON_PRODUCTION_LABELS.some((name) => label.startsWith(`${name}-`) ||
        label.endsWith(`-${name}`) ||
        label.includes(`-${name}-`));
/**
 * Which deployment a build is pointed at, worked out from its API endpoint.
 *
 * Production and development run separate user databases, so signing in to
 * the wrong one reports the same "incorrect email or password" as a genuinely
 * bad password. Naming the environment on the sign-in screen makes that
 * visible instead of baffling.
 */
export const describeEnvironment = (apiEndpoint) => {
    if (!apiEndpoint) {
        return { name: 'Unknown', host: '', isProduction: false };
    }
    let host;
    try {
        host = new URL(apiEndpoint).hostname;
    }
    catch {
        return { name: 'Unknown', host: apiEndpoint, isProduction: false };
    }
    if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
        return { name: 'Local', host, isProduction: false };
    }
    // Skip the public suffix: fly.dev would otherwise read as "dev".
    const labels = host.split('.').slice(0, -1);
    if (labels.some(isNonProductionLabel)) {
        return { name: 'Development', host, isProduction: false };
    }
    return { name: 'Production', host, isProduction: true };
};
